

var _log = []

export const logging = {
  debugMode:false,

  log: (...args: any[]) => {
    var s = args.map(r=>typeof r == 'object' ? JSON.stringify(r) : String(r))
    _log.push(s)
  },

  error: (...args: any[]) => {
    var s = args.map(r=>typeof r == 'object' ? JSON.stringify(r) : String(r))
    _log.push(['ERRIR',...s])
    console.error(args)
  }
}